import { useQuery } from "@tanstack/react-query"
import { fetchServerDate, fetchSupplierById, fetchAllClients, fetchSupplierUsers } from "../services/myProfile.service"

export const useMyProfileData = ({ userLogged }) => {
	const dataID = userLogged?.dataID

	const { data: serverDate } = useQuery({
		queryKey: ['serverDate'],
		queryFn: fetchServerDate,
		enabled: !!dataID,
		staleTime: 5 * 60 * 1000,
		refetchOnWindowFocus: false,
	})

	const { data: supplierData } = useQuery({
		queryKey: ['supplier-myProfile', dataID],
		queryFn: () => fetchSupplierById(dataID),
		enabled: !!dataID,
		staleTime: 0,
		refetchOnWindowFocus: false,
	})

	const { data: clients } = useQuery({
		queryKey: ['clients-myProfile'],
		queryFn: fetchAllClients,
		enabled: !!dataID,
		staleTime: 5 * 60 * 1000,
		refetchOnWindowFocus: false,
	})

	const { data: users } = useQuery({
		queryKey: ['supplierUsers-myProfile', dataID],
		queryFn: () => fetchSupplierUsers(dataID),
		enabled: !!dataID,
		staleTime: 0,
		refetchOnWindowFocus: false,
	})

	const isLoading = !supplierData || !serverDate || !clients

	return { supplierData, serverDate, clients, users: users ?? [], isLoading }
}
